(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4645],{

/***/ 13742:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Check; }
/* harmony export */ });
/* unused harmony export __iconNode */
/* harmony import */ var _createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91373);
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */



const __iconNode = [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]];
const Check = (0,_createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("check", __iconNode);


//# sourceMappingURL=check.js.map


/***/ }),

/***/ 7314:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Minus; }
/* harmony export */ });
/* unused harmony export __iconNode */
/* harmony import */ var _createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91373);
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */



const __iconNode = [["path", { d: "M5 12h14", key: "1ays0h" }]];
const Minus = (0,_createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("minus", __iconNode);


//# sourceMappingURL=minus.js.map


/***/ }),

/***/ 31012:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Plus; }
/* harmony export */ });
/* unused harmony export __iconNode */
/* harmony import */ var _createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91373);
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */



const __iconNode = [
  ["path", { d: "M5 12h14", key: "1ays0h" }],
  ["path", { d: "M12 5v14", key: "s699le" }]
];
const Plus = (0,_createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("plus", __iconNode);


//# sourceMappingURL=plus.js.map


/***/ }),

/***/ 63864:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/clm/analytics",
      function () {
        return __webpack_require__(14306);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 71575:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "fB": function() { return /* binding */ BuilderShowCaseSection; },
/* harmony export */   "uV": function() { return /* binding */ ShowCaseCard; }
/* harmony export */ });
/* unused harmony export showcaseData */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);



const showcaseData = [
    {
        id: 1,
        navText: "Persona"
    },
    {
        id: 2,
        navText: "Knowledge"
    },
    {
        id: 3,
        navText: "ActionBooks"
    },
    {
        id: 4,
        navText: "Boundaries"
    }
];
function ShowCase(param) {
    let { scrollToCard , activeIndex , setActiveIndex , categories , isDarkMode  } = param;
    const handleClick = (idx)=>{
        setActiveIndex(idx);
        scrollToCard === null || scrollToCard === void 0 ? void 0 : scrollToCard(idx); // Call scroll function
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "md:flex-row md:flex hidden flex-col justify-center items-center w-full gap-6",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex-1 md:w-auto w-full",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex flex-col ",
                    children: categories === null || categories === void 0 ? void 0 : categories.map((item, idx)=>{
                        const isActive = activeIndex === idx;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                            className: "relative h-[46px] bg-transparent ".concat(isActive ? "" : "border-t", " ").concat(isDarkMode ? "text-gray-300" : "text-gray-600", "  flex justify-start items-center gap-2 hover:bg-black/ ").concat(isActive ? "border-gray-900 font-bold" : "border-gray-300"),
                            onClick: ()=>handleClick(idx),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "rounded-full border font-medium ".concat(isDarkMode ? "border-white" : "border-black", "  flex justify-center items-center w-7 h-7  ").concat(isActive ? "".concat(isDarkMode ? "bg-white text-black" : "bg-black text-white") : "".concat(isDarkMode ? "text-gray-300" : "text-black bg-transparents")),
                                    children: idx + 1
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "relative z-10 text-lg whitespace-nowrap",
                                    children: item
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    // background: linear-gradient(275deg, #c86aff -8.37%, #3164ff)
                                    // want to use linear -gradient as bg color
                                    className: "absolute top-0 left-0 h-[3px] bg-gradient-to-r from-[#c86aff] to-[#3164ff] transition-all ease-linear duration-300",
                                    style: {
                                        width: isActive ? "100%" : "0%"
                                    }
                                })
                            ]
                        }, item.id);
                    })
                })
            })
        })
    });
}
function ShowCaseCard(param) {
    let { title , desc , imgSrc , titleSize ="4xl" , descSize ="xl" , gap =0 , mb =0 , idx =0 , cat  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex flex-col gap-4 md:gap-8 pb-12 md:pb-32",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex flex-col md:flex-row gap-3 md:gap-8 mb-8 ".concat(cat ? "border-t border-gray-300 pt-4" : "", " md:border-0 md:pt-0"),
                children: [
                    cat && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex gap-2 md:hidden ",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                // isActive ? "bg-black text-white" : "text-black bg-transparents"
                                className: "rounded-full border border-black flex justify-center items-center w-7 h-7 font-light bg-black text-white inline",
                                children: idx + 1
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "relative z-10 text-lg inline font-medium",
                                children: cat
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        className: "flex-1 text-2xl md:text-".concat(titleSize, " font-semibold"),
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "flex-1 text-".concat(descSize, " "),
                        children: desc
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                src: imgSrc,
                alt: "ai-agent-builder",
                width: 1280,
                height: 490,
                className: "w-full object-cover h-full rounded-xl md:rounded-[30px]"
            })
        ]
    });
}
const BuilderShowCaseSection = (param)=>{
    let { heading ="" , categories =[] , showcaseData =[] , isDarkMode =false  } = param;
    const [activeIndex, setActiveIndex] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    const cardRefs = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)([]);
    const scrollingRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(false);
    // const scrollToCard = (index) => {
    //   cardRefs.current[index]?.scrollIntoView({ behavior: "smooth" });
    //   setActiveIndex(index);
    // };
    // Scroll to card when activeIndex changes
    const scrollToCard = (index)=>{
        var _cardRefs_current_index;
        scrollingRef.current = true;
        (_cardRefs_current_index = cardRefs.current[index]) === null || _cardRefs_current_index === void 0 ? void 0 : _cardRefs_current_index.scrollIntoView({
            behavior: "smooth",
            block: "start"
        });
        // Reset scrolling flag after animation completes
        setTimeout(()=>{
            scrollingRef.current = false;
        }, 1000);
    };
    // Set up Intersection Observer to detect which card is in view
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const observerOptions = {
            root: null,
            rootMargin: "0px 0px -50% 0px",
            threshold: 0.1
        };
        const observerCallback = (entries)=>{
            // Ignore during programmatic scrolling
            if (scrollingRef.current) return;
            entries.forEach((entry)=>{
                if (entry.isIntersecting) {
                    const index = cardRefs.current.findIndex((ref)=>ref === entry.target);
                    if (index !== -1) {
                        setActiveIndex(index);
                    }
                }
            });
        };
        const observer = new IntersectionObserver(observerCallback, observerOptions);
        // Observe all cards
        cardRefs.current.forEach((card)=>{
            if (card) observer.observe(card);
        });
        return ()=>{
            observer.disconnect();
        };
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "max-w-screen-xl md:px-8 px-6 mx-auto py-10 ".concat(isDarkMode ? "text-white" : "text-gray-900"),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: "text-4xl md:text-5xl font-semibold mb-16 md:mb-24 md:pl-72",
                    children: heading
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "flex-2 w-[24%] pr-12 hidden md:block",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "w-full sticky top-[113px]",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ShowCase, {
                                    scrollToCard: scrollToCard,
                                    activeIndex: activeIndex,
                                    setActiveIndex: setActiveIndex,
                                    categories: categories,
                                    isDarkMode: isDarkMode
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "flex-1 ",
                            children: showcaseData.map((data, idx)=>{
                                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    ref: (el)=>cardRefs.current[idx] = el,
                                    className: "scroll-mt-[130px]",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ShowCaseCard, {
                                        title: data.heading,
                                        desc: data.subHeading,
                                        imgSrc: data.imgSrc,
                                        idx: idx,
                                        cat: categories === null || categories === void 0 ? void 0 : categories[idx]
                                    })
                                }, idx);
                            })
                        })
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 29937:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _v3_Buttons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56475);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);



const CLMHero2 = (param)=>{
    let { CLMHeroData  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
            className: "max-w-screen-xl mx-auto text-black relative mb-5 md:mb-24 md:mt-16 md:mt-0",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "relative z-10 flex flex-col items-center justify-start md:gap-6 px-4 md:px-0",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-col items-center justify-center gap-6 md:gap-7 mt-8 w-full ",
                        children: [
                            CLMHeroData.title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-2xl text-violet-600 uppercase",
                                children: CLMHeroData.title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                className: "text-5xl leading-[48px] md:text-[72px] md:leading-[72px] text-center max-w-full md:w-[95%] xl:w-[90%] font-semibold",
                                children: CLMHeroData.heading
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-lg font-medium text-gray-800 md:text-2xl text-center md:w-[80%]",
                                children: CLMHeroData.description
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_v3_Buttons__WEBPACK_IMPORTED_MODULE_1__/* .CLMButtonPrimary */ .IS, {
                                buttonText: CLMHeroData.btnText,
                                buttonUrl: CLMHeroData.btnUrl
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "max-w-screen-xl md:mx-8 mx-auto pt-8",
                        children: [
                            CLMHeroData.video && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", {
                                src: CLMHeroData.video,
                                alt: "ai-agent-builder",
                                width: 1216,
                                height: 500,
                                className: "rounded-xl",
                                autoPlay: true,
                                loop: true,
                                muted: true
                            }),
                            CLMHeroData.image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                src: CLMHeroData.image,
                                alt: "ai-agent-builder",
                                width: 1216,
                                height: 500,
                                className: "rounded-xl"
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CLMHero2);


/***/ }),

/***/ 8129:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _v3_Buttons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56475);


const CTASection = (param)=>{
    let { btnText , btnUrl  } = param;
    return /*#__PURE__*/ _jsxs("section", {
        className: "bg-[#f4f2f0] text-black py-16 md:px-10 px-4 xl:px-20 text-center",
        children: [
            /*#__PURE__*/ _jsx("h1", {
                className: "text-4xl md:text-7xl font-semibold leading-snug md:mt-20 mt-4 max-w-screen-xl mx-auto mb-16 tracking-tight",
                children: "Transform service with BoloSign's AI agent platform"
            }),
            /*#__PURE__*/ _jsx(CLMButtonPrimary, {
                buttonText: btnText,
                buttonUrl: btnUrl
            })
        ]
    });
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (CTASection)));


/***/ }),

/***/ 24062:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13742);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);





const EqualDivisionSection = (param)=>{
    let { title , heading , description , checks , image ="" , video ="" , bgColor , imageRight =true , opinion , imageRounded =true , leftDivStyle =""  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "".concat(bgColor, " py-7 md:py-32 transition-all duration-700"),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "max-w-screen-xl md:px-8 px-6 mx-auto grid md:grid-cols-2 gap-6 md:gap-12 xl:gap-20 items-start ".concat(leftDivStyle),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "".concat(imageRight ? "md:order-1" : "md:order-2", " order-1"),
                    children: [
                        title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "uppercase text-purple-900 mb-2 text-xs md:text-base font-semibold",
                            children: title
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "".concat(bgColor == "bg-dark" ? "text-white" : "", " text-[28px]  md:text-4xl xl:text-5xl font-semibold text-start ").concat(heading && "mb-6"),
                            children: heading
                        }),
                        description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "".concat(bgColor == "bg-dark" ? "text-white" : "text-gray-900", " mb-6  md:text-2xl font-semibold md:font-normal font-medium text-left"),
                            children: description
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                            className: "space-y-4 ".concat(bgColor == "bg-dark" ? "text-white" : "text-gray-800", " text-lg md:leading-none xl:leading-relaxed"),
                            children: checks.map((check, idx)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                    className: "flex items-start text-start",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                            className: "w-5 h-5 text-gray-800 bg-purple-200 rounded-full p-1 mr-2 mt-1 shrink-0"
                                        }),
                                        check
                                    ]
                                }, idx))
                        }),
                        opinion && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                            className: "".concat(bgColor == "bg-dark" ? "text-white" : "text-black", " mb-6  md:text-base w-[70%] pl-4 font-semibold font-medium mt-10 text-start hidden md:block"),
                            children: [
                                opinion,
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: "-BoloSign User"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "bg-color  rounded-2xl relative  ".concat(imageRight ? "order-2" : "order-1"),
                    children: [
                        image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                            src: image,
                            alt: "Contract Creation",
                            width: 500,
                            height: 500,
                            className: "w-full ".concat(imageRounded ? "rounded-2xl" : "")
                        }),
                        video && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", {
                            src: video,
                            autoPlay: true,
                            muted: true,
                            loop: true,
                            className: "w-full h-full object-cover rounded-2xl"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (EqualDivisionSection);


/***/ }),

/***/ 74791:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7314);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31012);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);



function FaqItem(param) {
    let { question , answer , isOpen , onToggle  } = param;
    const contentRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const [height, setHeight] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (isOpen && contentRef.current) {
            setHeight(contentRef.current.scrollHeight);
        } else {
            setHeight(0);
        }
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        onClick: onToggle,
        className: "px-8 py-7 transition-all duration-300",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                className: "flex justify-between items-center w-full text-left gap-4",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                        className: "text-[20px] leading-[26px] font-semibold",
                        children: question
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "text-purple-600 text-xl border-2 border-purple-600 rounded-full p-1",
                        children: isOpen ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            size: 20
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            size: 20
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                ref: contentRef,
                style: {
                    maxHeight: "".concat(height, "px"),
                    overflow: "hidden",
                    transition: "max-height 0.3s ease, opacity 0.3s ease",
                    opacity: isOpen ? 1 : 0
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: answer
                    },
                    className: "mt-6 text-gray-700 text-[18px] leading-[26px] font-medium"
                })
            })
        ]
    });
}
function FaqList(param) {
    let { faqs  } = param;
    const [openIndex, setOpenIndex] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: faqs.map((faq, index)=>{
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: " bg-white rounded-2xl border border-surface-dark mt-4 text-left w-full mx-auto ".concat(openIndex === index ? "" : "hover:bg-surface-dark", " transition-all  duration-300"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FaqItem, {
                    question: faq === null || faq === void 0 ? void 0 : faq.question,
                    answer: faq === null || faq === void 0 ? void 0 : faq.answer,
                    isOpen: openIndex === index,
                    onToggle: ()=>setOpenIndex(openIndex === index ? null : index)
                }, index)
            }, index);
        })
    });
}
const FAQ2 = (param)=>{
    let { faqData , heading , description  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "md:w-[920px] max-w-full mx-auto",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                className: "text-4xl md:text-5xl font-semibold leading-snug mb-8",
                children: heading
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "text-[18px] leading-[22px] font-medium md:w-[80%] mx-auto w-full mt-2 mb-12",
                children: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FaqList, {
                faqs: faqData
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FAQ2);


/***/ }),

/***/ 14306:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_CLM_BuilderShowCase__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71575);
/* harmony import */ var components_CLM_CLMHero2__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29937);
/* harmony import */ var components_CLM_CTASection__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8129);
/* harmony import */ var components_CLM_EqualDivisionSection__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(24062);
/* harmony import */ var components_CLM_FAQ2__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74791);
/* harmony import */ var components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(56475);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67294);
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(43138);










const CLMHeroData = {
    // title: "Reporting",
    heading: "Discover what’s inside your contracts",
    description: "BoloSign helps you find key data, improve workflows, and make smarter decisions—all from your contracts.",
    image: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_9__.BASE_ASSETS_URL, "/v2/clm/clm/contract-analysis-hero.gif"),
    btnText: "Take a Quick Demo",
    btnUrl: "/clm/request-demo"
};
const contractAnalysisFaqData = [
    {
        question: "What insights can I discover with BoloSign’s Contract Analysis?",
        answer: "• Get a clear view of how many contracts you manage and the different categories (e.g., sales, procurement, NDAs) over time.\n\n• Evaluate how efficiently your approval and review workflows are operating, so you can spot slow points.\n\n• Anticipate upcoming renewals or expirations and stay ahead of important deadlines."
    },
    {
        question: "How do these analytics help my legal team stay proactive?",
        answer: "• Track key dates—like renewal and expiration—so your team can start negotiations well before deadlines.\n\n• Spot recurring bottlenecks (for instance, approval delays) and streamline those stages to keep contracts moving.\n\n• Align contract strategies with broader business objectives by analyzing trends in your contract data."
    },
    {
        question: "Who should leverage BoloSign’s Contract Analysis tools?",
        answer: "• **Legal Departments** wanting to tighten contract cycle times and reduce manual follow-ups.\n\n• **Contract Managers** who need in-depth reporting on where each agreement stands—draft, review, or signed.\n\n• **Business Leaders & Ops Teams** seeking a snapshot of contractual risks, obligations, and operational efficiency."
    },
    {
        question: "What kinds of data and visualizations are available?",
        answer: "• **Lifecycle Tracking:** See each contract’s journey—from initial draft to final signature—in one view.\n\n• **Timeline Comparisons:** Measure planned versus actual turnaround on approvals, redlining, and renewals.\n\n• **Segmented Overviews:** Break down contract statuses (e.g., Drafted, Pending Approval, Active, Expired) by department, contract type, or region."
    },
    {
        question: "Can I customize these dashboards to fit my organization?",
        answer: "• **Select Essential Metrics:** Choose which data points matter most—approval times, renewal forecasts, or volume by contract type.\n\n• **Apply Flexible Filters:** Narrow the view to a specific department, business unit, or time span to analyze trends in detail.\n\n• **Save Custom Views:** Create and store dashboard layouts so your team can instantly access the analyses they use most."
    },
    {
        question: "How does BoloSign protect the security and compliance of my contract information?",
        answer: "• We adhere to industry-leading encryption standards—both in transit and at rest—so contract content remains confidential.\n\n• Role-based access controls ensure only authorized users can view or act on contract analytics.\n\n• Regular security audits and compliance checks (ESIGN, GDPR, etc.) keep your data protected. For a full list of certifications and policies, please visit https://security.boloforms.com/"
    }
];
const showcaseData = [
    {
        heading: "Gain Full Control Over Your Contract Lifecycle",
        subHeading: "Track trends, monitor key contract types, and stay on top of every stage—from draft to execution.",
        imgSrc: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_9__.BASE_ASSETS_URL, "/v2/clm/clm/analysis-initiated-this-year.png")
    },
    {
        heading: "Optimize Approval Workflows with Actionable Insights",
        subHeading: "Track approval status, monitor turnaround times, and uncover trends to drive faster, smarter contract approvals.",
        imgSrc: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_9__.BASE_ASSETS_URL, "/v2/clm/clm/analysis-approvals.png")
    },
    {
        heading: "Improve Contract Review Efficiency with Real-Time Insights",
        subHeading: "Track review progress, analyze timelines by contract type, and uncover trends to streamline your entire review process.",
        imgSrc: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_9__.BASE_ASSETS_URL, "/v2/clm/clm/analysis-reviews.png")
    },
    {
        heading: "Accelerate Contract Cycles with Turnaround Time Insights",
        subHeading: "Analyze time spent at each stage—from drafting to redlining—and compare review cycles by contract type to optimize every workflow.",
        imgSrc: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_9__.BASE_ASSETS_URL, "/v2/clm/clm/analysis-average-drafting.png")
    }
];
const ContractAnalysis = (param)=>{
    let { isDarkMode , setIsDarkMode  } = param;
    const sectionRef = (0,react__WEBPACK_IMPORTED_MODULE_8__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_8__.useEffect)(()=>{
        const section = sectionRef.current;
        if (!section) return;
        const handleScroll = ()=>{
            const rect = section.getBoundingClientRect();
            const topTrigger = 120; // or some margin like 100
            const bottomTrigger = window.innerHeight;
            const isInView = rect.top <= topTrigger && rect.bottom >= bottomTrigger / 2;
            setIsDarkMode(isInView);
        };
        window.addEventListener("scroll", handleScroll, {
            passive: true
        });
        handleScroll(); // Initial check
        return ()=>window.removeEventListener("scroll", handleScroll);
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "Contract Analysis & Reporting | BoloSign CLM"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: "Gain deep insights into your contract workflows with BoloSign's Contract Analysis. Monitor key metrics, optimize processes, and make data-driven decisions."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "keywords",
                        content: "Contract Analysis, Contract Reporting, CLM Analytics, Contract Workflows, BoloSign CLM"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: "https://www.bolosign.com/clm/analytics/"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_CLMHero2__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                CLMHeroData: CLMHeroData
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "text-start md:text-center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        className: "text-3xl font-semibold md:text-5xl px-6 md:px-0 mb-4 pt-10 md:pt-20 ",
                        children: "Total visibility into your contract workflow"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "text-xl md:text-2xl w-[85%] xl:w-[60%] mx-auto md:-mb-16",
                        children: "BoloSign offers real-time dashboards with 30+ key metrics, helping you monitor, analyze, and optimize your contracting process across every stage of the lifecycle."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_EqualDivisionSection__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        // title="Templates"
                        // heading="Easily search and stay updated on important contracts"
                        image: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_9__.BASE_ASSETS_URL, "/v2/clm/clm/contract-analysis-visibility-formated.gif"),
                        bgColor: "bg-transparent",
                        imageRight: true,
                        checks: [
                            "Track the full contract journey — Monitor lifecycle stages, approval times, and review turnaround to identify delays and optimize performance.",
                            "Drill into the data — Use filters like date range, contract type, user, and workflow to uncover trends and gain deeper insights.",
                            "Drive alignment across teams — Share clear, actionable data to keep legal, sales, and business stakeholders on the same page."
                        ],
                        opinion: "“Having data makes it easier to provide concrete proof instead of estimates.”",
                        imageRounded: false
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "text-start md:text-center bg-cream",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        className: "text-3xl md:text-5xl mb-6 pt-20 md:pt-32 font-semibold px-6 md:px-0",
                        children: "Optimize your contracting with actionable insights"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "text-xl md:text-2xl w-[85%] xl:w-[60%] mx-auto md:-mb-16",
                        children: "BoloSign shows you what’s working—and what’s not—so you can streamline processes, reduce delays, and improve outcomes across your contract workflow."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_EqualDivisionSection__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        // title="Templates"
                        // heading="Easily search and stay updated on important contracts"
                        image: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_9__.BASE_ASSETS_URL, "/v2/clm/clm/contract-analysis-average-time.png"),
                        bgColor: "bg-transparent",
                        imageRight: false,
                        checks: [
                            "Eliminate approval delays – Identify and fix bottlenecks in your contract review and approval workflows to speed up deal cycles.",
                            "Simplify high-volume negotiations – Analyze trends to optimize workflows for frequently used contract types like NDAs and MSAs.",
                            "Customize SLAs by contract type – Leverage turnaround time data to set realistic, data-driven expectations for different agreements."
                        ],
                        opinion: "“With data, we found contracts get signed faster when we share responsibility for filling in details—it’s improved our turnaround time noticeably.”"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "text-start md:text-center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        className: "text-3xl md:text-5xl mb-6 pt-20 md:pt-32 font-semibold px-6 md:px-0",
                        children: "Highlight the impact of your legal team"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "text-xl md:text-2xl w-[85%] xl:w-[60%] mx-auto md:-mb-16",
                        children: "BoloSign equips Legal with the data they need to demonstrate value—track performance, share success metrics, and respond to business questions with clear, contract-driven insights."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_EqualDivisionSection__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        // title="Templates"
                        // heading="Easily search and stay updated on important contracts"
                        image: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_9__.BASE_ASSETS_URL, "/v2/clm/clm/analysis-avg-response.png"),
                        bgColor: "bg-transparent",
                        imageRight: true,
                        checks: [
                            "Track improvements over time – Use Turnaround Time metrics to highlight faster contract cycles and workflow efficiency.",
                            "Report with confidence – Build quarterly reports to spotlight team wins and uncover areas for improvement.",
                            "Drive alignment across teams – Share data-driven insights that resonate with business stakeholders and leadership."
                        ],
                        opinion: "“This helps us show leadership how much we’re handling—and makes a strong case for expanding our team.”"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "transition-colors duration-300  ".concat(isDarkMode ? "bg-dark text-white" : "bg-white text-black"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                    ref: sectionRef,
                    className: "pt-20",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_BuilderShowCase__WEBPACK_IMPORTED_MODULE_2__/* .BuilderShowCaseSection */ .fB, {
                        heading: "Turn Contracts Into Insights with Powerful Dashboards",
                        categories: [
                            "Lifecycle",
                            "Approval",
                            "Review",
                            "Turnaround Time"
                        ],
                        showcaseData: showcaseData,
                        isDarkMode: isDarkMode
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "bg-[#f4f2f0] text-black py-16 md:px-10 px-4 xl:px-20 text-center md:pt-24 pt-12 ",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_FAQ2__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    faqData: contractAnalysisFaqData,
                    heading: "FAQs"
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (ContractAnalysis);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(63864); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);